'use client';

import { Paperclip } from 'lucide-react';
import type { SupportAttachment } from '../services/support-api';

export function MessageAttachments({
  attachments,
}: {
  attachments?: SupportAttachment[] | null;
}) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {attachments.map((a) => {
        const href = a.url.startsWith('/api') ? a.url : `/api/v1${a.url}`;
        const isImage = a.mimeType.startsWith('image/');
        return isImage ? (
          <a key={a.url} href={href} target="_blank" rel="noreferrer" className="block">
            <img
              src={href}
              alt={a.name}
              className="h-20 w-20 rounded-lg border border-neutral-200 object-cover dark:border-neutral-700"
            />
          </a>
        ) : (
          <a
            key={a.url}
            href={href}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 rounded-lg border border-neutral-200 bg-white px-2.5 py-1.5 text-[0.75rem] text-neutral-700 hover:bg-neutral-50 dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-300"
          >
            <Paperclip className="h-3.5 w-3.5" strokeWidth={1.75} />
            {a.name}
          </a>
        );
      })}
    </div>
  );
}
